module.exports = __webpack_public_path__ + "img/lock.7bad3998.svg";